export default `



            ██      ██
           █  █    █  █
            

                    
               [ , , , , , , , , , , , , , , , ,█,█,█,█,█,█,█,█,█,█,█,█,█,█,█,█][ , , , , , , , , , , , , , , , , ,█,█,█,█,█,█,█,█,█,█,█,█,█,█,█,█][ , , , , , , , , , , , , , , , , ,█,█,█,█,█,█,█,█,█,█,█,█,█,█,█,█][ , , , , , , , , , , , , , , , , ,█,█,█,█,█,█,█,█,█,█,█,█,█,█,█,█] 
             [█,█,█,█,█,█,█,█,█,█,█,█,█,█,█,█, , , , , , , , , , , , , , , , , ]██████[█,█,█,█,█,█,█,█,█,█,█,█,█,█,█,█, , , , , , , , , , , , , , , , , ]

`